"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Pinterest =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pinterest, _PureComponent);

  function Pinterest() {
    _classCallCheck(this, Pinterest);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pinterest).apply(this, arguments));
  }

  _createClass(Pinterest, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          height = _this$props.height,
          width = _this$props.width;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        width: width,
        height: height,
        className: className,
        style: style,
        viewBox: "0 0 17 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, this.props), _react.default.createElement("title", null, "Pinterest"), _react.default.createElement("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, _react.default.createElement("g", {
        transform: "translate(0.500000, 0.000000)",
        fill: color
      }, _react.default.createElement("path", {
        d: "M8,0 C3.582,0 0,3.582 0,8 C0,11.389 2.109,14.286 5.084,15.452 C5.015,14.819 4.952,13.846 5.112,13.154 C5.258,12.53 6.05,9.178 6.05,9.178 C6.05,9.178 5.811,8.699 5.811,7.99 C5.811,6.878 6.456,6.048 7.259,6.048 C7.941,6.048 8.271,6.56 8.271,7.175 C8.271,7.861 7.834,8.887 7.608,9.838 C7.42,10.635 8.008,11.284 8.793,11.284 C10.215,11.284 11.308,9.784 11.308,7.62 C11.308,5.705 9.932,4.365 7.966,4.365 C5.69,4.365 4.354,6.073 4.354,7.838 C4.354,8.525 4.619,9.263 4.949,9.663 C5.015,9.742 5.024,9.812 5.005,9.893 C4.944,10.146 4.809,10.688 4.783,10.8 C4.748,10.946 4.667,10.978 4.515,10.907 C3.516,10.441 2.891,8.98 2.891,7.808 C2.891,5.284 4.725,2.967 8.177,2.967 C10.952,2.967 13.109,4.944 13.109,7.587 C13.109,10.344 11.371,12.563 8.958,12.563 C8.147,12.563 7.385,12.142 7.124,11.645 C7.124,11.645 6.723,13.172 6.625,13.546 C6.445,14.241 5.958,15.112 5.631,15.644 C6.38,15.875 7.175,16 8,16 C12.418,16 16,12.418 16,8 C16,3.582 12.418,0 8,0",
        id: "Fill-5"
      }))));
    }
  }]);

  return Pinterest;
}(_react.PureComponent);

Pinterest.displayName = 'Pinterest'; // Prop Types

Pinterest.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
Pinterest.defaultProps = {
  className: '',
  style: {},
  height: '16',
  width: '17',
  color: 'black'
};

var _default = (0, _styledComponents.withTheme)(Pinterest);

exports.default = _default;